import styled, { css, keyframes } from 'styled-components';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

const bounceKeyframes = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0);
  }

  50% {
    opacity: 0;
    transform: translateY(-1rem);
  }

  51% {
    opacity: 0;
    transform: translateY(0);
  }

  75% {
    opacity: 1;
  }
`;

export const ScrollIndicator = styled.a`
  display: none;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 100%;
  background-color: ${nuDSColor('white', 'dark')};
  position: absolute;
  left: 50%;
  bottom: 3rem;
  transition-property: transform, opacity;
  transition-duration: .4s;
  animation-name: ${bounceKeyframes};
  animation-duration: 1.7s;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.76, 0, 0.24, 1);

  ${breakpointsMedia({
    lg: css`
      display: block;
    `,
  })}
`;

ScrollIndicator.displayName = 'ScrollIndicator';
